import React from 'react';
import Icon from '../../Icon/components/Icon';

const LargeSectionTitleIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="4" y1="5" x2="20" y2="5" strokeWidth="4"/>
      <line x1="4" y1="10" x2="20" y2="10"/>
      <line x1="4" y1="15" x2="20" y2="15"/>
      <line x1="4" y1="20" x2="20" y2="20"/>
    </Icon>
  );
};

export default LargeSectionTitleIcon;
